import * as React from "react";
import { TiTick } from "react-icons/ti";

export const DietFilterOption = ({ title, isSelected, onSelect }) => {
  // Step 1: Handle the selection toggle with onSelect
  const handleSelect = () => {
    onSelect(isSelected ? null : title); // Toggle selection when clicked
  };

  return (
    <div
      onClick={handleSelect} // Step 2: Handle click to toggle selection
      className="flex items-center justify-center gap-10 px-6 md:h-[83.66px] w-[80%] sm:w-[80%] md:w-[80%] sm:h-[56.47px] h-[56.47px] lg:h-[111px] py-5 lg:w-full font-medium leading-none text-black whitespace-nowrap bg-white rounded-3xl max-w-[627px] shadow-[0px_4px_4px_rgba(0,0,0,0.25)] max-md:px-5 max-md:max-w-full cursor-pointer"
    >
      <div
        className={`flex shrink-0 rounded-full sm:w-[35.61px] md:w-[42.76px] md:h-[42.76px] sm:h-[35.61px] w-[35.61px] h-[35.61px] lg:h-[60px] lg:w-[60px] ${
          isSelected
            ? "bg-[#AC313C] justify-center items-center" // Filled circle with checkmark when selected
            : "border-[#AC313C] border-2" // Empty circle with border when not selected
        }`}
      >
        {/* Display the filled checkmark if selected */}
        {isSelected ? <TiTick className="text-white text-[40px]" /> : null}
      </div>
      <div className="flex-auto body my-auto w-[443px] text-[22.38px] max-md:max-w-full md:text-[28.16px] sm:text-[22.38px] lg:text-[34px]">
        {title} 
      </div>
    </div>
  );
};
